"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.PoiDualList = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _reselect = require("reselect");

var _commonDualList = _interopRequireDefault(require("./common-dual-list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getPois = function getPois(state) {
  return state.informationLists.pois;
};

var poiSelector = (0, _reselect.createSelector)(getPois, function (pois) {
  return pois.map(function (_ref) {
    var id = _ref.id,
        name = _ref.name;
    return {
      id: id,
      label: name
    };
  });
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    pois: poiSelector(state)
  };
};

exports.mapStateToProps = mapStateToProps;

var PoiDualList = function PoiDualList(_ref2) {
  var pois = _ref2.pois,
      selectedPois = _ref2.selectedPois,
      allPoisSelected = _ref2.allPoisSelected,
      _onChange = _ref2.onChange;
  return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
    icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.POIWithText, null),
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "duallist.pois",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement(_commonDualList["default"], {
    items: pois,
    allItemsSelected: allPoisSelected,
    selectedItems: selectedPois,
    onChange: function onChange(_ref3) {
      var allItemsSelected = _ref3.allItemsSelected,
          selectedItems = _ref3.selectedItems;
      return _onChange({
        allPoisSelected: allItemsSelected,
        selectedPois: selectedItems
      });
    }
  }));
};

exports.PoiDualList = PoiDualList;
PoiDualList.propTypes = {
  allPoisSelected: _propTypes["default"].bool,
  pois: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
  selectedPois: _propTypes["default"].arrayOf(_propTypes["default"].number),
  onChange: _propTypes["default"].func
};
PoiDualList.defaultProps = {
  allPoisSelected: true,
  pois: [],
  selectedPois: [],
  onChange: function onChange() {}
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(PoiDualList);

exports["default"] = _default;